import { createSlice } from "@reduxjs/toolkit";

export const counterSlice = createSlice({
  name: "remedy",
  initialState: {
    remedyItem: {},
  },
  reducers: {
    loadRemedy: () => {},
    loadRemedySuccess: (state, action) => {
      state.remedyItem = action.payload.data;
    },
    loadRemedyFailure: () => {},
    setRemedy: (state, action) => {
      state.remedyItem = action.payload;
    },
    addRemedy : () => {},
    editRemedy : () => {},
  },
});

export const {
  loadRemedy,
  loadRemedySuccess,
  loadRemedyFailure,
  addRemedy,
  editRemedy,
  setRemedy
} = counterSlice.actions;

export default counterSlice.reducer;

export const getRemedy = (state) => state.remedy.remedyItem;


